import { Navbar } from "./components/Navbar/Navbar";
import '../src/App.css'
import { Into } from "./components/into/Into";
import { Services } from "./components/Services/Services";
import { Experience } from "./components/Experience/Experience";
import { Works } from "./components/Works/Works";
import { Contact } from "./components/Contact/Contact";
import { useContext } from "react";
import { themeContext } from "./Context";

function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="App" style={{background: darkMode?'black':'', color: darkMode?'white':''}}>
      <Navbar/>
      <Into/>
      <Services/>
      <Experience/>
      <Works/>
      <Contact/>
    </div>
  );
}

export default App;
